module.exports = __webpack_public_path__ + "img/quatrieme-couverture-pigments-eternite.9798a1ba.png";